import React from "react";
import { fmt } from "../uiUtils";

const s = {
  overlay: { position: "fixed", inset: 0, background: "rgba(15,23,42,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2000 },
  card: { width: "100%", maxWidth: 420, maxHeight: "80vh", background: "var(--panel-2)", borderRadius: 14, overflow: "hidden", display: "flex", flexDirection: "column" },
  head: { padding: 16, fontWeight: 500, fontSize: 16, borderBottom: "1px solid var(--line)", display: "flex", justifyContent: "space-between" },
  x: { border: "none", background: "none", cursor: "pointer", fontSize: 18, color: "var(--ink-2)" },
  list: { overflow: "auto", padding: 8 },
  item: { display: "flex", justifyContent: "space-between", padding: "12px 14px", borderRadius: 10, cursor: "pointer", border: "1px solid var(--line)", marginBottom: 8 },
};

export default function VariantModal({ product, variants, onPick, onClose }) {
  return (
    <div className="qv-dlg-overlay" style={s.overlay} onClick={onClose}>
      <div className="qv-dlg-card" style={s.card} onClick={(e) => e.stopPropagation()}>
        <div style={s.head}>
          <span>{product.title} — choose option</span>
          <button style={s.x} onClick={onClose}>✕</button>
        </div>
        <div style={s.list}>
          {variants.map((v) => (
            <div key={v.variantId || v.name} style={s.item} onClick={() => onPick(v)}>
              <span style={{ fontWeight: 500 }}>{v.name}</span>
              <span style={{ color: "var(--accent)", fontWeight: 500 }}>{fmt(v.price)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
